import React, { useEffect, useState } from 'react';
import AdminSearchBarHeader from '../component/AdminSearchBarHeader';
import {
  Avatar,
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Col,
  Flex,
  Image,
  Input,
  Progress,
  Radio,
  Row,
  Select,
  Spin,
  Upload,
  message,
} from 'antd';
import routes from '../../../controller/Routes';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import CandidateReviewModal from '../component/modal/CandidateReviewModal';
import { getCandidatebyId } from '../../../controller/api/candidateServices';
import { getAdminDetail } from '../../../controller/localStroageHandler';
import CandidateTestTable from './CandidateTestTable';
import { getResume } from '../../../controller/api/globalServices';

const CandidateView = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [candidateData, setCandidateData] = useState(null);
  const [openCandidateReviewMOdal, setOpenCandidateReviewModal] =
    useState(false);
  const [candidateResponseData, setcandidateResponseData] = useState(null);
  const [testResult, setTestResult] = useState([]);
 const userDetail = getAdminDetail();
  useEffect(()=>{
    getCandidatebyId({id: userDetail?.organization_id?._id,candidateId:params?.id}).then((res)=>{
setCandidateData(res?.data?.data)
    }).catch((err)=>console.log("err ===>>>> jbd",err))
  },[])
  return (
    <>
      <div className='w-100 h-100 p-4 bg-light overflow-y-auto'>
        <AdminSearchBarHeader />
        <Row align={'middle'} className='mt-2 mb-2'>
          <Col span={24} className='fs-5 fw-semibold'>
            <Breadcrumb
              items={[
                {
                  title: (
                    <Link
                      to={routes.admin.dashboard.candidates}
                      className='text-decoration-none text-capitalize'
                    >
                      Candidate
                    </Link>
                  ),
                },
                {
                  title: <div className='text-capitalize'>{params.id}</div>,
                },
              ]}
            />
          </Col>
        </Row>
        <Spin spinning={loading}>
          <Row gutter={[12, 15]}>
            <Col xl={8} lg={8} md={10} sm={12} xs={24} className=''>
              <div className=' h-100'>
                <Card className='text-center h-100 d-flex justify-content-center align-items-center'>
                  <div className=' h-100 w-100 d-flex flex-column  gap-2 align-items-center '>
                    <Avatar
                      style={{
                        backgroundColor: '#C24A4A',
                        verticalAlign: 'middle',
                      }}
                      size='large'
                    >
                      A
                    </Avatar>
                    <div className='d-flex flex-column'>
                      <span className='text-black fw-semibold fs-5'>
                        {candidateData?.firstName} {candidateData?.lastName}
                      </span>
                      <span className='text-muted fs-6'>
                        {' '}
                        {candidateData?.location || '-'}
                      </span>
                    </div>
                    <div className='d-flex gap-3 flex-wrap justify-content-end'>
                    <Button
                          type='text'
                          className='text-color-custom fs-6 fw-semibold d-flex justify-content-center align-items-center custom-hover-btn'
                          onClick={()=>{getResume(candidateData?.resumeUrl)}}
                        >
                          Resume
                        </Button>
                    </div>
                  </div>
                </Card>
              </div>
            </Col>
            <Col xl={16} lg={16} md={14} sm={12} xs={24} className=''>
              <div className=' h-100'>
                <Card className='h-100'>
                  <div className='d-flex flex-column gap-2'>
                    <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Email ID</span>
                      <span className='text-muted'>
                        {candidateData?.email || '-'}
                      </span>
                    </div>
                    <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Phone No.</span>
                      <span className='text-muted'>
                     {candidateData?.phoneNo || '-'}
                      </span>
                    </div>
                    <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Experience</span>
                      <span className='text-muted'>
                        {candidateData?.experience || '-'}
                      </span>
                    </div>
                    <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Intitude Name</span>
                      <span className='text-muted'>
                        {candidateData?.instituteName || '-'}{' '}
                      </span>
                    </div>
                    {/* <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Profile</span>
                      <span className='text-muted'>
                      {candidateData?.profile || '-'}
                      </span>
                    </div> */}
                    <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Location</span>
                      <span className='text-muted'>
                        {candidateData?.location || '-'}
                      </span>
                    </div>
                    <div className='d-flex flex-column fw-semibold gap-2'>
                      <span className='text-black'>Key Skills</span>
                      <span className='d-flex flex-wrap gap-2'>
                        {candidateData?.keySkills?.map((item, index) => {
                          return (
                            <span
                              class='badge skill-bg-color text-muted'
                              key={index}
                            >
                              {item?.name}
                            </span>
                          );
                        })}
                      </span>
                    </div>
                  </div>
                </Card>
              </div>
            </Col>
            {/* <Col xl={8} lg={8} md={10} sm={12} xs={24} className=''>
              <div className=' h-100'>
                <Card className='text-center h-100'>
                  <div className='d-flex flex-column gap-2'>
                    <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Test</span>
                      <span className='text-muted'>
                        {candidateData?.test_name || '-'}
                      </span>
                    </div>
                    <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Score</span>
                      <span className='text-muted'>
                        <span className='text-black fw-medium'>
                          {candidateData?.score}
                        </span>
                        /{candidateData?.total_score}
                      </span>
                    </div>
                    <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Percentage</span>
                      <span className='text-muted'>
                        {candidateData?.percentage || '-'}
                        {candidateData?.percentage && '%'}
                      </span>
                    </div>
                    <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Status</span>
                      <span
                        className={`${
                          candidateData?.status == 'completed'
                            ? 'text-success'
                            : candidateData?.status == 'inprogress'
                            ? 'text-warning'
                            : 'text-danger'
                        }`}
                      >
                        {candidateData?.status}
                      </span>
                    </div>
                    <div className='d-flex justify-content-between align-items-center fw-semibold'>
                      <span className='text-black'>Submission Date</span>
                      <span className='text-muted'>
                        {candidateData?.end_time
                          ? moment(candidateData?.end_time).format('MM/DD/YYYY')
                          : '-'}
                      </span>
                    </div>
                  </div>
                </Card>
              </div>
            </Col> */}
            <Col  className=''>
              <div className=' h-100'>
                <Card className='h-100'>
                  <div className='w-100 border-bottom pb-2 fs-5 fw-bold'>
                    Test Section Score
                  </div>
                  <div className='mt-3'>
                 {candidateData&& <CandidateTestTable candidateData={candidateData} setOpenCandidateReviewModal={setOpenCandidateReviewModal}
                              setcandidateResponseData={setcandidateResponseData} />}
                  </div>
                </Card>
              </div>
            </Col>
          </Row>
        </Spin>
      </div>
      {openCandidateReviewMOdal && (
        <CandidateReviewModal
          openCandidateReviewMOdal={openCandidateReviewMOdal}
          setOpenCandidateReviewModal={setOpenCandidateReviewModal}
          candidateResponseData={candidateResponseData}
          setcandidateResponseData={setcandidateResponseData}
        />
      )}
    </>
  );
};

export default CandidateView;
